import { EditFaq } from './edit-faq';

export default EditFaq;